module.exports = __webpack_public_path__ + "static/img/icon_logo.e6284e9d.png";